import React from 'react'
import tw from 'twin.macro'
import styled from 'styled-components'
import { useTranslation } from 'contexts/Localization'
import { useResizeObserver } from '@nominex/dex-uikit'
import { SlButton, SlIcon } from '@shoelace-style/shoelace/dist/react'
import { getBridgeLink } from 'config/constants'
import { useWagmi } from 'libs/wagmi'

const WidgetWrapper = styled.div<{ horizontal: boolean }>`
  ${tw`flex flex-col items-center relative gradient-promo-violet rounded-12 py-20 px-24 overflow-hidden`}
  ${({ horizontal }) => (horizontal ? tw`sm:flex-row justify-between gap-16 sm:gap-32` : tw`h-[430px] gap-16`)};
`

const StyledImage = styled.img<{ horizontal: boolean }>`
  ${tw`absolute bottom-0`}
  ${({ horizontal }) => (horizontal ? tw`left-[50%]` : tw`left-[-15%]`)};
`
const StyledLink = tw.a`
  flex items-center text-14 text-primary font-medium
`

const BinanceBridgeWidget: React.FC = () => {
  const { t } = useTranslation()
  const { ref, refWidth } = useResizeObserver()
  const isHorizontalView = refWidth > 258
  const { chainId } = useWagmi()

  return (
    <WidgetWrapper ref={ref} horizontal={isHorizontalView}>
      <div className={`flex flex-col gap-8 z-[1] ${refWidth > 845 ? 'w-[45%]' : ''}`}>
        <h5 className="text-20 text-primary font-medium leading-32">{t('How to trade NMX tokens')}</h5>
        <p className="text-14 text-secondary">
          {t(
            'Trading of NMX tokens is possible only in Binance Smart Chain network. Please, use the bridge to transfer tokens to BSC network.',
          )}
        </p>
      </div>
      <div className={`flex flex-col items-center gap-12 w-full z-[1] ${isHorizontalView ? 'sm:w-auto' : ''}`}>
        <SlButton className="w-full" variant="primary" href={getBridgeLink(chainId)} target="_blank">
          {t('NMX Bridge')}
        </SlButton>
        <StyledLink
          href="https://nomiswap.gitbook.io/home/core-products/nmx-token-bridge"
          target="_blank"
          rel="noreferrer"
        >
          {t('How to use it?')}
          <SlIcon className="square-16" name="arrow-right" library="unicons" />
        </StyledLink>
      </div>
      {(!isHorizontalView || refWidth > 845) && (
        <StyledImage
          horizontal={isHorizontalView}
          src="/images/banners/nmx-transfer.png"
          alt="NMX transfer"
          height={isHorizontalView ? 119 : 235}
          width={isHorizontalView ? 189 : 290}
        />
      )}
    </WidgetWrapper>
  )
}

export default BinanceBridgeWidget
